import React from 'react';
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";

const needAssistance = () => {
  return (
    <div className="wrapper">
      <Breadcrumbs/>
      <h1 className="two-three-rows__title">Contact the Care Center</h1>
      <div className="contact-care-center">
        <h2 className="contact-section__info-block-title contact-section__info-block-title--phone mbl mts">Call</h2>
        <p className="contact-section__info-block-subtitle">Customer CARE</p>
        <p className="customer-care-center__text">For general Cargo questions including tracking, rates, or how to open a Southwest Cargo® Account, please contact Customer CARE.</p>
        <div className="contact-care-center__table-container">
          <table className="contact-care-center__table">
            <tbody>
            <tr>
              <td className="contact-section__info-block-text contact-care-center__text-spaced">Mon-Fri</td>
              <td className="contact-section__info-block-text contact-section__info-block-text--dark-blue contact-section__info-block-text--spaced">6:30 a.m. —  8:00 p.m.</td>
            </tr>
            <tr>
              <td className="contact-section__info-block-text contact-care-center__text-spaced">Sat-Sun</td>
              <td className="contact-section__info-block-text contact-section__info-block-text--dark-blue contact-section__info-block-text--spaced">8:00 a.m. —  5:00 p.m.</td>
            </tr>
            </tbody>
          </table>
          <table className="contact-care-center__table contact-care-center__table--right">
            <tbody>
            <tr>
              <td className="contact-section__info-block-text">Domestic</td>
              <td className="contact-section__info-block-text contact-section__info-block-text--dark-blue contact-section__info-block-text--spaced">1 (800) 533-1222</td>
            </tr>
            <tr>
              <td className="contact-section__info-block-text">International</td>
              <td className="contact-section__info-block-text contact-section__info-block-text--dark-blue contact-section__info-block-text--spaced">1 (214) 792-1333</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
};

export default needAssistance;



// WEBPACK FOOTER //
// ./src/pages/About/NeedAssistance.js